import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  divider: {
    color: theme.palette.primary.main
  },
  content: {
    // minHeight: "100px",
    textAlign: "center",
    margin: "50px"
  },
  buttonsContainer: {
    textAlign: "Right"
  },
  button: {
    textTransform: "none",
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
});

export const AreYouSureDialog = withStyles(styles)(
  ({ title, onClose, classes, onDelete }) => (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      scroll="body"
      open
      spacing={0}
      className={classes.root}
      onClose={onClose}
    >
      <DialogTitle onCancel={onClose}>
        <b>Are You Sure?</b>
      </DialogTitle>
      <DialogContent>
        <div className={classes.content}>
          <Typography variant="h5">Delete "{title}"?</Typography>
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            aria-label="Edit"
            color="secondary"
            variant="contained"
            className={classes.button}
            onClick={onDelete}
          >
            Delete
          </Button>
          <Button
            aria-label="Edit"
            color="primary"
            variant="contained"
            className={classes.button}
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
);
